import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { PromptSetApiService } from '../../shared/api.service';

@Component({
    selector: 'delete-prompt-dialog',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatProgressSpinnerModule, CommonModule],
    templateUrl: './delete-prompt-dialog.component.html',
    styleUrl: './delete-prompt-dialog.component.scss'
})
export class DeletePromptDialogComponent {

    isSubmitting = false;

    constructor(public dialogRef: MatDialogRef<DeletePromptDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private promptApiService: PromptSetApiService) {
    }

    deletePrompt() {
        this.isSubmitting = true;
        const promptId = this.data.prompt_identifier || this.data.promptIdentifier;
        const promptIdPayload = { promptIdentifier: promptId };
        this.promptApiService.deletePrompt(promptIdPayload).subscribe({
            next: (response: any) => {
                this.isSubmitting = false;
                this.dialogRef.close(promptId);
            },
            error: (error: any) => {
                console.error('Error deleting prompt:', error);
                this.isSubmitting = false;
                this.dialogRef.close(false);
            }
        });
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
